import { EVENT_PAYLOAD } from '#pplx/frontend/framework/instrumentation/types.js';
import { useInstrumentation } from '#pplx/frontend/framework/instrumentation/useInstrumentation.js';
import { usePathname } from '#pplx/frontend/router/usePathname.js';
import { useEffect, useRef } from 'react';
// Single-file event: defined here at its only call site rather than in a shared package.
const timeSpentEvent = EVENT_PAYLOAD;
const TICK_SIZE = 1000;
const MAX_THRESHOLD_MS = 256000;
// Small allowlist to start. Will expand over time as needed.
const PATH_WHITELIST = [
    /^\/finance(\/|$)/,
    /^\/app\/finance(\/|$)/,
    /^\/health(\/|$)/,
    /^\/app\/health(\/|$)/,
];
export function useTimeSpentTracker() {
    const pathname = usePathname();
    const { track } = useInstrumentation();
    const timeRef = useRef(0);
    useEffect(() => {
        if (!PATH_WHITELIST.some((p) => p.test(pathname)))
            return;
        timeRef.current = 0;
        let nextThreshold = TICK_SIZE;
        const interval = setInterval(() => {
            if (document.visibilityState !== 'visible')
                return;
            timeRef.current += TICK_SIZE;
            if (timeRef.current >= nextThreshold) {
                track(timeSpentEvent({
                    name: 'time spent',
                    data: {
                        url: pathname,
                        timespentMs: timeRef.current,
                    },
                }));
                nextThreshold *= 2;
                if (nextThreshold > MAX_THRESHOLD_MS) {
                    clearInterval(interval);
                }
            }
        }, TICK_SIZE);
        return () => clearInterval(interval);
    }, [pathname, track]);
}
//# sourceMappingURL=useTimeSpentTracker.js.map